import axios from "axios";
import router from "@/router";

const service = axios.create({
  baseURL: `${process.env.VUE_APP_BRAND_CHANNEL_API_ENDPOINT}`
});

service.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // TODO: registrar no Rollbar!
    if (!error.response) {
      // eslint-disable-next-line prettier/prettier
      console.error("Erro de conexão. Verifique sua rede ou entre em contato com a OvermediaCast");
    } else if (error.response.status === 404) {
      router.push({ name: "pageNotFound" });
      return Promise.reject(error);
    } else if (error.response.status >= 500) {
      console.error("Erro no servidor");
      router.push({ name: "pageNotFound" });
      return Promise.reject(error);
    } else {
      console.error("Erro!");
    }
  }
);

export default service;
